import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';

import Avatar from './Avatar';

export const UserAvatar = ({ history, user, onLogoutClick, onContactClick }) => {
  const [isPanelOpen, openPanel] = useState(false);

  const handleLogout = () => onLogoutClick();

  const handleAvatarPress = () => !isPanelOpen && openPanel(true);

  const handleNaviagteAccount = () => {
    openPanel(false);
    history.push('/account');
  };

  const handleNavigateConnections = () => {
    openPanel(false);
    history.push('/connections');
  };

  const handlePanelClick = (e) => {
    e.nativeEvent.stopImmediatePropagation();
    e.preventDefault();
  };

  const onUsersClick = () => {
    openPanel(false);
    history.push('/users');
  };

  const handleContactClick = () => {
    openPanel(false);
    onContactClick();
  };

  useEffect(() => {
    const handleHidePanel = () => openPanel(false);

    isPanelOpen
      ? window.addEventListener('click', handleHidePanel)
      : window.removeEventListener('click', handleHidePanel);

    return () => window.removeEventListener('click', handleHidePanel);
  }, [isPanelOpen]);

  return (
    <React.Fragment>
      <Avatar
        user={user}
        open={isPanelOpen}
        onLogoutClick={handleLogout}
        onUsersClick={onUsersClick}
        onPanelClick={handlePanelClick}
        onAvatarClick={handleAvatarPress}
        onContactClick={handleContactClick}
        onAccountClick={handleNaviagteAccount}
        onConnectionsClick={handleNavigateConnections}
      />
    </React.Fragment>
  );
};

export default withRouter(UserAvatar);
